/* DreamCloud → Scheduled jobs: each job's last run, and its history on a tap.
 *
 * "Last run" is the later of the scheduled and the manual one (lastRun in
 * js/rules/dreamcloud.js), so a job re-run from the Actions section shows the
 * re-run. History is fetched when a row is opened, not with every poll.
 */
import * as Vue from 'vue';
import { dreamcloud } from '../dreamcloud.js';
import { lastRun, runState, runSummary, jobName, formatWhen } from '../rules/dreamcloud.js';
import { useDrilldown, DcRunTable } from './dc-drilldown.js';

export const DcJobs = {
  name: 'DcJobs',
  components: { DcRunTable: DcRunTable },
  setup: function () {
    var state = dreamcloud.state;

    var list = Vue.computed(function () {
      return (Array.isArray(state.jobs) ? state.jobs : []).map(function (j) {
        var run = lastRun(j);
        return {
          job: j.job, name: jobName(j.job), state: runState(run),
          time: run ? formatWhen(run.started_at) : '—', summary: runSummary(run)
        };
      });
    });

    var drill = useDrilldown();

    function toggle(job) {
      drill.toggle(job, 'job', function () { return dreamcloud.invoke('jobs', { job: job }); });
    }

    return { state: state, list: list, open: drill.state, toggle: toggle };
  },
  template: [
    '<section class="dc-section dc-card dc-jobs" aria-labelledby="dc-jobs-h">',
    '  <h3 class="dc-h" id="dc-jobs-h">Scheduled jobs <span class="dc-muted">(last run)</span></h3>',
    '  <p v-if="!state.jobs" class="dc-muted">{{ state.error ? "Nothing has loaded yet." : "Loading…" }}</p>',
    '  <ul v-else class="dc-joblist">',
    '    <li v-for="j in list" :key="j.job">',
    '      <button type="button" class="dc-job" @click="toggle(j.job)"',
    '        :aria-expanded="open.key === j.job ? \'true\' : \'false\'">',
    '        <span class="dc-job__name"><span class="dc-dot" :class="\'is-\' + j.state"></span>{{ j.name }}</span>',
    '        <span class="dc-job__time">{{ j.time }}</span>',
    '        <span class="dc-job__sum" :class="{ \'is-failed\': j.state === \'failed\' }">{{ j.summary }}</span>',
    '      </button>',
    '      <div v-if="open.key === j.job" class="dc-rows">',
    '        <p v-if="open.loading" class="dc-muted">Loading&hellip;</p>',
    '        <p v-else-if="open.error" class="dc-error">{{ open.error }}</p>',
    '        <p v-else-if="!open.rows.length" class="dc-muted">No runs on record.</p>',
    '        <dc-run-table v-else :runs="open.rows" />',
    '      </div>',
    '    </li>',
    '  </ul>',
    '</section>'
  ].join('\n')
};
